import PageHero from "@/components/PageHero";
import EngagementsAnchorNav from "@/components/EngagementsAnchorNav";
import WhyTheyStay from "@/components/WhyTheyStay";
import ProcessSteps from "@/components/ProcessSteps";
import ChannelManager from "@/components/ChannelManager";
import OperationsNumbers from "@/components/OperationsNumbers";
import ResultsTeaser from "@/components/ResultsTeaser";
import BoosterBanner from "@/components/BoosterBanner";
import WhatsAppGallery from "@/components/WhatsAppGallery";
import Testimonials from "@/components/Testimonials";
import BrochureCTA from "@/components/BrochureCTA";
import SEO from "@/components/SEO";

const Engagements = () => {
  return (
    <div data-testid="page-engagements">
      <SEO
        title="Nos engagements, Conciergerie Airbnb Bretagne"
        description="Pourquoi 94 % de nos propriétaires restent : suivi humain, pricing dynamique, transparence totale, équipes locales bretonnes. Découvrez notre méthode et nos preuves."
        keywords="engagements conciergerie Bretagne, transparence tarifs Airbnb, accompagnement propriétaire Saint-Malo, qualité conciergerie locative, 94 % rétention propriétaires"
        breadcrumbs={[
          { name: "Accueil", path: "/" },
          { name: "Nos engagements", path: "/engagements" },
        ]}
      />
      <PageHero
        overline="Nos engagements"
        title="94 % de nos propriétaires"
        italic="restent avec nous"
        description="Voici pourquoi : 8 raisons concrètes, un process limpide, des chiffres réels, et des dizaines de voyageurs qui nous écrivent spontanément. Découvrez notre méthode, étape par étape."
        image="https://images.unsplash.com/photo-1646489346674-b8640e514453?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxzYWludCUyMG1hbG8lMjBicmV0YWduZXxlbnwwfHx8fDE3Nzc4NDM1NDJ8MA&ixlib=rb-4.1.0&q=85&w=1800"
        cta={{ to: "#why-they-stay", label: "Découvrir la méthode" }}
      />

      {/* Sticky sub-nav for fast navigation */}
      <EngagementsAnchorNav />

      {/* === ACT 1, TRUST: why 94% stay === */}
      <div id="why-they-stay">
        <WhyTheyStay />
      </div>

      {/* === ACT 2, METHOD: how it works === */}
      <div id="process-steps">
        <ProcessSteps />
      </div>

      {/* === ACT 3, REACH: multi-platform diffusion === */}
      <div id="channel-manager">
        <ChannelManager />
      </div>

      {/* === ACT 4, PROOF in numbers === */}
      <div id="operations-numbers">
        <OperationsNumbers />
      </div>

      {/* === ACT 5, RESULTS TEASER : 3 cas clients réels === */}
      <div id="results-teaser">
        <ResultsTeaser />
      </div>

      {/* === ACT 6, REVENUE PROMISE === */}
      <div id="booster-banner">
        <BoosterBanner />
      </div>

      {/* === ACT 7, SOCIAL PROOF (voyageurs) === */}
      <div id="whatsapp-gallery">
        <WhatsAppGallery />
      </div>

      {/* === ACT 8, SOCIAL PROOF (propriétaires) === */}
      <div id="engagement-testimonials">
        <Testimonials />
      </div>

      {/* === ACT 9, FINAL CTA === */}
      <div id="brochure-cta">
        <BrochureCTA />
      </div>
    </div>
  );
};

export default Engagements;
